import React, { useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "./BasicDrawer.scss";

export function BasicDrawer({ show, close, children, width }) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div className="basic-drawer__overlay" onClick={close} />
      <div className="basic-drawer" style={{ width: width || "90vw" }}>
        <div className="basic-drawer__header">
          <Icon
            name="close"
            className="basic-drawer__close"
            onClick={close}
          />
        </div>
        <div className="basic-drawer__content">{children}</div>
      </div>
    </>
  );
}
